import { render, staticRenderFns } from "./GroupStage.vue?vue&type=template&id=2325e93a&scoped=true&"
import script from "./GroupStage.vue?vue&type=script&lang=js&"
export * from "./GroupStage.vue?vue&type=script&lang=js&"
import style0 from "./GroupStage.vue?vue&type=style&index=0&id=2325e93a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2325e93a",
  null
  
)

export default component.exports